export default __webpack_public_path__ + "static/psmlogo-cf2c1c7ff836a649a4bff2789adfd472.png";